import AdvancePaymentTicketDetail from './AdvancePaymentTicketDetail';

export default AdvancePaymentTicketDetail;
